import * as Icons from "lucide-react";
import { WHY_CHOOSE, FOUNDER_URL } from "../../constants/data";
import { Sparkle, Heart } from "../doodles/Doodles";
import useCategoryImages from "../../hooks/useCategoryImages";
import TileImage from "../shared/TileImage";

export default function WhyChoose() {
  const overrides = useCategoryImages();
  return (
    <section className="section-y relative overflow-hidden" data-testid="why-choose-section">
      <Sparkle color="#FFD93D" className="absolute top-6 right-12 w-7 animate-twinkle"/>
      <Heart color="#FF6B9D" className="absolute bottom-10 left-12 w-7 animate-bounce-doodle"/>

      <div className="container-x relative">
        <div className="text-center max-w-2xl mx-auto mb-6">
          <p className="label-small text-xs sm:text-sm">✨ Why Naathi Charami ✨</p>
          <h2 className="font-doodle text-2xl sm:text-3xl mt-1 text-[#2D2424]">Crafted with <span className="text-[#FF6B9D]">love</span>, every time</h2>
        </div>
        <div className="grid lg:grid-cols-3 gap-6 items-center">
          {/* Founder */}
          <div className="flex flex-col items-center text-center" data-testid="founder-strip">
            <div className="relative">
              <div className="w-32 h-32 sm:w-36 sm:h-36 overflow-hidden rounded-full border-4 border-[#2D2424]" style={{ boxShadow: "5px 5px 0 #FF6B9D" }}>
                <TileImage
                  src={overrides.founder}
                  loaded={overrides.loaded}
                  fallback={FOUNDER_URL}
                  alt="Monalika Reddy"
                  className="w-full h-full object-cover"
                  icon="heart"
                />
              </div>
              <Sparkle color="#FFD93D" className="absolute -top-3 -right-3 w-9 animate-twinkle"/>
            </div>
            <p className="font-doodle text-2xl text-[#2D2424] mt-3">Monalika Reddy</p>
            <p className="doodle-pill bg-[#FFE7F1] mt-1 text-xs">Founder ♥</p>
          </div>

          {/* All points in a single compact tile */}
          <div className="lg:col-span-2 max-w-md mx-auto lg:mx-0 w-full" data-testid="why-choose-single-tile">
            <div className="doodle-card p-4 sm:p-5 bg-[#FFE7F1]" style={{ boxShadow: "5px 5px 0 #2D2424" }}>
              <p className="font-doodle text-lg sm:text-xl text-[#7A1F2B] mb-3">Why you&apos;ll love us</p>
              <ul className="space-y-2">
                {WHY_CHOOSE.map((w, idx) => {
                  const Icon = Icons[w.icon] || Icons.Check;
                  return (
                    <li key={w.title} className="flex items-start gap-2.5" data-testid={`why-point-${idx}`}>
                      <span className="w-7 h-7 shrink-0 bg-white border-2 border-[#2D2424] flex items-center justify-center rounded-full mt-0.5">
                        <Icon className="w-3.5 h-3.5 text-[#7A1F2B]" strokeWidth={2.5}/>
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="font-doodle text-sm sm:text-base text-[#2D2424] leading-tight">{w.title}</p>
                        <p className="text-xs font-hand text-[#5C5555] leading-snug">{w.desc}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
